module.exports = __webpack_public_path__ + "media/application/images/2018/email-white-85aa3085654e9af10b5c4c3b25fa215a.svg";